import { ImAddressBook } from "react-icons/im";
import { ImCalendar, ImPriceTag } from "react-icons/im";

export const SidebarData = [
    { 
        title: "Contacts",
        icon: <ImAddressBook />,
        link: "/contacts"
    },
    {
        title: "Calendar",
        icon: <ImCalendar />,
        link: "/calendar"
    },
    {
        title: "Tags",
        icon: <ImPriceTag />,
        link: "/tags"

    }
]
